import { create } from 'zustand';

type OneClickTradingModalState = {
  isOpen: boolean;
  open: () => void;
  close: () => void;
};

export const useOneClickTradingModalStore =
  create<OneClickTradingModalState>((set) => ({
    isOpen: false,
    open: () => set({ isOpen: true }),
    close: () => set({ isOpen: false }),
  }));


